var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-down-arrow.svg",
    clipPath: "url(#clip0_17145_1466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.65609 2.32232C4.6241 2.27586 4.58129 2.23787 4.53135 2.21162C4.48142 2.18538 4.42585 2.17166 4.36944 2.17166C4.31302 2.17166 4.25745 2.18538 4.20752 2.21162C4.15758 2.23787 4.11477 2.27586 4.08278 2.32232L0.944242 6.85577C0.907913 6.90806 0.886609 6.9693 0.882645 7.03285C0.87868 7.0964 0.892206 7.15982 0.921753 7.21622C0.951301 7.27262 0.99574 7.31984 1.05024 7.35276C1.10474 7.38567 1.16722 7.40302 1.2309 7.40292L7.50798 7.40292C7.5715 7.40266 7.63375 7.38509 7.68803 7.35209C7.74231 7.3191 7.78657 7.27193 7.81605 7.21566C7.84553 7.15939 7.85911 7.09615 7.85534 7.03274C7.85156 6.96933 7.83058 6.90815 7.79463 6.85577L4.65609 2.32232Z",
    fill: "#218931"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17145_1466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.36944,
    height: 8.36944,
    fill: "white",
    transform: "translate(8.5542 9.14655) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrow_green.218ac72df06b9f989aaaf334c32bd40a.svg";
export { ForwardRef as ReactComponent };